/**************************************************
 * Nombre:       Dialogo_Soporte_Ver
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import Formulario_Soporte_Ver from "../Formularios/Formulario_Soporte_Ver";

const Dialogo_Soporte_Ver = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Soporte_Ver props={props}/>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Soporte_Ver